const e=async(e,t)=>{let{data:n}=await e.post(`/roles`,t);return n};export{e as createRole};
//# sourceMappingURL=create-role.mjs.map